import React from "react";
import {
  Typography,
  Box,
  Breadcrumbs,
  Theme,
  Chip,
  Button,
  Tooltip,
  Stack,
  FormControlLabel,
  Switch,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { IBreadcrumbProps } from "./IBreadcrumbProps";
import { AddOutlined, ArrowBack } from "@mui/icons-material";
import styled from "@emotion/styled";
import { useBillingCompanyContext } from "../../../providers";
import { BillingInfoDialog } from "../../../views/dashboard/Dashboard/BillingInfoDialog";
import { useAuth } from "../../../contexts/AuthProvider/AuthProvider";

export const Breadcrumb: React.FC<IBreadcrumbProps> = ({
  subtitle,
  items,
  title,
  children,
  actionButtonText,
  actionButtonIcon,
  onActionButtonClick,
  rightSwitch,
  shouldDisableActionButton = false,
  actionButtonColor,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const [openCompanyInfoDialog, setCompanyInfoDialog] =
    React.useState<boolean>(false);

  return (
    <Box display={"flex"} sx={{ mb: 2 }}>
      <Box
        sx={(theme: Theme) => ({
          pl: 1,
          pr: 1,
          mr: 1,
          display: "flex",
          justifyContent: "left",
          alignItems: "center",
        })}
      >
        <ArrowBack
          color="action"
          sx={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
      </Box>
      {
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0, mr: isMobileView ? 1 : 0 }}>
            <Typography color="textSecondary" fontWeight="400" variant="h4">
              {subtitle}
            </Typography>

            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {items
                ? (isMobileView ? items.slice(items.length - 1) : items).map(
                    (item) => (
                      <div key={item.title}>
                        {item.to ? (
                          <StyledBreadcrumb
                            component="a"
                            href={item.to}
                            label={item.title}
                            size={isMobileView ? "small" : "medium"}
                          />
                        ) : (
                          <Typography
                            color="textPrimary"
                            textTransform={"capitalize"}
                            sx={{
                              ...(isMobileView && {
                                fontSize: "0.875rem",
                              }),
                            }}
                          >
                            {item.title}
                          </Typography>
                        )}
                      </div>
                    ),
                  )
                : ""}
            </Breadcrumbs>
            {/* <Typography fontWeight="700" variant="h3">
        {title}
      </Typography> */}
          </Box>
          <Box sx={{ flexShrink: 0, ml: isMobileView ? 1 : 2 }}>
            <Stack direction={"row"} spacing={isMobileView ? 1 : 2} alignItems="center">
              {children}
              {onActionButtonClick && (

                <Tooltip
                  title={
                    shouldDisableActionButton
                      ? "You have reached the limit to use this action"
                      : ""
                  }
                  arrow
                >
                  <span>
                    <Button
                      variant="contained"
                      color={actionButtonColor}
                      onClick={onActionButtonClick}
                      startIcon={
                        actionButtonIcon ? actionButtonIcon : <AddOutlined />
                      }
                      disabled={shouldDisableActionButton}
                      size={isMobileView ? "small" : "medium"}
                      sx={{
                        ...(isMobileView && {
                          fontSize: "0.75rem",
                          padding: "4px 8px",
                          minWidth: "auto",
                        }),
                      }}
                    >
                      {actionButtonText}
                    </Button>
                  </span>
                </Tooltip>
              )}

              {rightSwitch && (
                <FormControlLabel
                  control={
                    <Switch
                      size="medium"
                      checked={rightSwitch.checked}
                      onChange={rightSwitch.onChange}
                      name="gilad"
                    />
                  }
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontWeight: 600,
                      fontSize: "1rem",
                    },
                  }}
                  label={rightSwitch.label}
                />
              )}
            </Stack>
          </Box>
        </Box>
      }
      {openCompanyInfoDialog && (
        <BillingInfoDialog
          open={openCompanyInfoDialog}
          onClose={() => setCompanyInfoDialog(false)}
        />
      )}
    </Box>
  );
};

const StyledBreadcrumb = styled(Chip)(({ theme }: any) => {
  return {
    backgroundColor: theme.palette.primary.main,
    height: theme.spacing(3),
    color: "#fff",
    fontWeight: theme.typography.fontWeightRegular,
    textTransform: "capitalize",
  };
}) as typeof Chip;
